define('app/dashboard/panels/MarketingDashboardPanel',['require','./DashboardPanel','glu/util','hbs!./MarketingDashboardPanel.hbs'],function(require) {

	'use strict';
	var DashboardPanel = require('./DashboardPanel'),
		_ = require('glu/util');

	return DashboardPanel.extend({
		template: require('hbs!./MarketingDashboardPanel.hbs'),

		ui: function() {
			return _.extend(DashboardPanel.prototype.ui, {
				$topContainer: '.top-container',
				$bottomLeftContainer: '.bottom-left-container',
				$bottomRightContainer: '.bottom-right-container',
				marketingWidgets: '#dashboard-tab-my-widgets'
			});
		},

		/**
		 * My reports and others tabs do not exist with this dashboard panel.
		 */
		addViews: function() {

		},

		/**
		 * Disable drag and drop for this dashboard panel.
		 */
		enableDragAndDrop: function() {

		},


		/**
		 * Determine the best location for the widget.  For now we have to use the widget name to determine
		 * the best location.  In the future we may want to add something to the report model to make this less fragile.
		 */
		addWidget: function(view, model) {
			var widgetName = model.get('name');

			var $renderedEl = view.render().$el;

			$renderedEl.attr('data-qa', model.get('name'));

			switch (widgetName) {
				// Request marketings
				case 'Request Volume':
					this.ui.marketingWidgets.find('.marketing-widgets-container .requests .line').append($renderedEl);
					break;
				case 'Requests Started':
					this.ui.marketingWidgets.find('.marketing-widgets-container .requests .col-1').append($renderedEl);
					break;
				case 'Requests Submitted':
					this.ui.marketingWidgets.find('.marketing-widgets-container .requests .col-2').append($renderedEl);
					break;
				case 'Requests by Product':
					this.ui.marketingWidgets.find('.marketing-widgets-container .requests .col-3').append($renderedEl);
					break;
				case 'Cross-sell':
					this.ui.marketingWidgets.find('.marketing-widgets-container .requests .col-4').append($renderedEl);
					break;
				case 'Requests by Age Group':
					this.ui.marketingWidgets.find('.marketing-widgets-container .applicants .col-1').append($renderedEl);
					break;
				case 'Median Age by Product':
					this.ui.marketingWidgets.find('.marketing-widgets-container .applicants .col-2').append($renderedEl);
					break;
				case 'Joint Applicant Requests':
					this.ui.marketingWidgets.find('.marketing-widgets-container .applicants .col-3').append($renderedEl);
					break;
				case 'Existing Customers':
					this.ui.marketingWidgets.find('.marketing-widgets-container .applicants .col-4').append($renderedEl);
					break;
				case 'Initial Channel':
					this.ui.marketingWidgets.find('.marketing-widgets-container .channels .col-1').append($renderedEl);
					break;
				case 'Last Channel':
					this.ui.marketingWidgets.find('.marketing-widgets-container .channels .col-2').append($renderedEl);
					break;
				case 'Initial Device':
					this.ui.marketingWidgets.find('.marketing-widgets-container .channels .col-3').append($renderedEl);
					break;
				case 'Completion Device':
					this.ui.marketingWidgets.find('.marketing-widgets-container .channels .col-4').append($renderedEl);
					break;
			}

			this.widgets.push(view);
		}
	});
});

